import React from 'react';
import { cn } from './lib/utils';

/* Action row for forms — parity with legacy `~co/common/form` Buttons.
   Spans the settings grid; `variant='between'` splits the row. */
/* Joined controls — port of `~co/common/button` ButtonsGroup.
   Children .ui-btn get merged corners + hairline separators. */
export const ButtonsGroup = React.forwardRef(function ButtonsGroup(
  { className, ...etc },
  ref,
) {
  return (
    <div {...etc} className={cn('ui-buttons-group', className)} ref={ref} />
  );
});

export function ButtonRow({ className, variant = 'default', ...props }) {
  return (
    <div
      {...props}
      data-variant={variant}
      className={cn(
        'col-span-full flex flex-wrap items-center justify-end gap-[var(--padding-small)] [&_[role=button]]:min-w-[2.2rem]',
        variant === 'between' && 'justify-between',
        className,
      )}
    />
  );
}
